import { useEffect, useRef } from 'react'

// this component comes (mostly) from Sandy Gifford at Reclaim
type ReclaimSchedulingLinkEmbedProps = {
  linkId: string
}

export const ReclaimSchedulingLinkEmbed = ({ linkId }: ReclaimSchedulingLinkEmbedProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const hasAppendedScriptRef = useRef(false) // prevent this component from rendering two of itself in React.StrictMode

  useEffect(() => {
    const s = document.createElement('script')
    s.src = 'https://app.reclaim.ai/scripts/embed-scheduling-link.0.x.x.js'
    s.dataset.id = linkId

    if (!hasAppendedScriptRef.current) {
      ref.current?.append(s)
      hasAppendedScriptRef.current = true
    }

    // The embed script replaces itself with an object,
    // so we can't update things like the source after it
    // executes.  Because of this, this component relies
    // on `linkId` never changing.
  }, [])

  return <div ref={ref} />
}
